import { useEffect, useState } from 'react';
import { IIssueType, IIssueTypeParams } from '../interfaces/issueType';
import { issueTypeService } from '../services';
import { IPagination } from '../interfaces';
import { commonConstants } from '../constants';
import { defaultPageSize } from 'constants/pagination';

const { DEFAULT_SIZE_CHANGER } = commonConstants;

const useIssueType = (defaultParam: IIssueTypeParams) => {
  const [issueTypes, setIssueType] = useState<IIssueType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [params, setParams] = useState<IIssueTypeParams>(defaultParam);
  const [pagination, setPagination] = useState<IPagination>({
    ...DEFAULT_SIZE_CHANGER,
  });

  const fetchIssueType = async () => {
    try {
      setLoading(true);
      const { data } = await issueTypeService.getIssueType(params);
      const { items, pagination: pager } = data;
      setIssueType(items);

      setPagination({
        ...pagination,
        total: pager.totalItems,
        current: pager.currentPage,
        pageSize: pager.pageSize,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination: IPagination) => {
    const newQueryParams = {
      ...params,
      page: Number(pagination.current),
      pageSize: Number(pagination.pageSize),
    };
    setParams(newQueryParams);
  };

  useEffect(() => {
    if (params.pageSize !== defaultPageSize) fetchIssueType().then();
  }, [params]);

  return {
    issueTypes,
    loading,
    params,
    setParams,
    pagination,
    handleTableChange,
    fetchIssueType,
  };
};

export default {
  useIssueType,
};
